import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "@/landing/landing.css";

const LINKS = [
  { href: "/#how", label: "How it works" },
  { href: "/providers", label: "Find a Provider" },
  { href: "/#pricing", label: "Pricing" },
  { href: "/articles", label: "Articles" },
];

export function PublicNav() {
  const navRef = useRef(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const nav = navRef.current;
    const onScroll = () => nav && nav.classList.toggle("scrolled", window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  return (
    <div className="landing-page" style={{ overflow: "visible", zIndex: 70 }}>
      <div className="announce" data-testid="public-nav-announcement">Now starting with <b>Ontario support pathways</b> — built to grow with families across Canada.</div>
      <header className="nav" id="nav" ref={navRef}>
        <div className="wrap nav-inner">
          <Link className="brand" to="/" aria-label="KidPath home" data-testid="public-nav-brand">
            <img src="/assets/kidpath-mark-light.png" alt="" />
            <span><span className="k">Kid</span><span className="p">Path</span></span>
          </Link>
          <nav className={`nav-links${open ? " open" : ""}`} id="navlinks" aria-label="Primary">
            {LINKS.map((l) => (
              <Link key={l.href} to={l.href} onClick={() => setOpen(false)} data-testid={`public-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                {l.label}
              </Link>
            ))}
          </nav>
          <div className="nav-cta">
            <Link className="signin" to="/login" data-testid="public-nav-signin">Sign in</Link>
            <Link className="btn btn-primary" to="/register" data-testid="public-nav-start-free">Start free</Link>
            <button className="menu-btn" id="menuBtn" aria-label="Menu" aria-expanded={open}
              onClick={() => setOpen((o) => !o)} data-testid="public-nav-menu-btn">
              <span></span><span></span><span></span>
            </button>
          </div>
        </div>
      </header>
      {open && <div className="nav-scrim open" onClick={() => setOpen(false)} aria-hidden="true" data-testid="public-nav-scrim" />}
    </div>
  );
}
